import { reportClientError } from "@/lib/report-client-error";

/**
 * Next's client instrumentation file: it runs before the app becomes
 * interactive, which is why the listeners live here rather than in a component
 * mounted by the root layout. A component only attaches after hydration, and
 * the failures worth catching most — a chunk that will not load, a WebView that
 * chokes on the bundle — happen before that.
 *
 * These two listeners are most of this feature's value on the client. The
 * riskiest code in this app (the Capacitor shell, barcode scanning, the
 * native-auth bridge) fails asynchronously, which a React error boundary never
 * sees.
 */
window.addEventListener("error", (event) => {
  const error = event.error as Error | undefined;
  reportClientError({
    name: error?.name ?? "Error",
    // event.message is the fallback for cross-origin and non-Error throws; the
    // ignore-list drops the ones that carry nothing usable.
    message: error?.message ?? event.message ?? "",
    stack: error?.stack ?? null,
  });
});

window.addEventListener("unhandledrejection", (event) => {
  const reason: unknown = event.reason;

  if (reason instanceof Error) {
    reportClientError({ name: reason.name, message: reason.message, stack: reason.stack });
    return;
  }

  // Rejections with a non-Error value are still recorded rather than dropped:
  // `throw "nope"` and a rejected fetch body are real bugs, and the stringified
  // reason is usually enough to find them.
  reportClientError({ name: "UnhandledRejection", message: String(reason), stack: null });
});
